import { SVGProps } from "react";

export function Rome2RioIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="#DE007B"
      strokeWidth={2.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M16 1.8C21.2 1.8 24.6 5.6 24.6 10C24.6 12.6 23.6 14.2 22.6 15.4C24 16.8 24.6 18.4 24.6 20.4C24.6 24.6 19.4 28.4 16 30.4C12.6 28.4 7.4 24.6 7.4 20.4C7.4 18.4 8 16.8 9.4 15.4C8.4 14.2 7.4 12.6 7.4 10C7.4 5.6 10.8 1.8 16 1.8Z" />
      <path d="M8.2 12.8C9.4 10.8 11.6 10.2 14 10.2H22" />
      <path d="M10.8 18.6L15.6 22.4L23.4 16.4" />
    </svg>
  );
}
